import {
  createRow as _createRow,
  flexRender as _flexRender,
  type Renderable,
} from '@tanstack/react-table'
import type { ReactNode } from 'react'
import type {
  DataTableColumnHelper,
  DataTableDisplayColumnDef,
  DataTableGroupColumnDef,
  DataTableInstance,
  DataTableRow,
  DataTableRowData,
} from '../types'
import { getAllLeafColumnDefs, getColumnId } from './column.utils'

export const flexRender = _flexRender as (
  Comp: Renderable<unknown>,
  props: unknown,
) => JSX.Element | ReactNode

export function createMRTColumnHelper<
  TData extends DataTableRowData,
>(): DataTableColumnHelper<TData> {
  return {
    accessor: (accessor, column) =>
      typeof accessor === 'function'
        ? ({
            ...column,
            accessorFn: accessor,
            // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
          } as any)
        : {
            ...column,
            accessorKey: accessor,
          },
    display: (column) => column as DataTableDisplayColumnDef<TData>,
    group: (column) => column as DataTableGroupColumnDef<TData>,
  }
}

export const createRow = <TData extends DataTableRowData>(
  table: DataTableInstance<TData>,
  originalRow?: TData,
  rowIndex = -1,
  depth = 0,
  subRows?: DataTableRow<TData>[],
  parentId?: string,
): DataTableRow<TData> =>
  _createRow(
    // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
    table as any,
    'mrt-row-create',
    originalRow ??
      Object.assign(
        {},
        ...getAllLeafColumnDefs(table.options.columns).map((col) => ({
          [getColumnId(col)]: '',
        })),
      ),
    rowIndex,
    depth,
    // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
    subRows as any,
    parentId,
  ) as DataTableRow<TData>
